module.exports=function(scope){ return `<!-- Load the FaceTec SDK localization strings -->
<script type="text/javascript" src="ZoomStrings.en.js"></script>
<!-- Load the FaceTec FaceTec package -->
<script type="text/javascript" src="../ZoomAuthentication.js/ZoomAuthentication.js"></script>
`};


// WEBPACK FOOTER //
// ./src/resources/code/web/quickstart/localization-load-example.html.tpl